import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ icon: Icon, title, body, cta, to, index = 0 }) {
  return (
    <Link
      to={to}
      className="group card-lift relative flex flex-col h-full bg-white border border-gold/20 p-8 lg:p-10 hover:border-rose/40 hover:bg-blush-soft/40"
      data-testid={`service-card-${index}`}
    >
      <span className="absolute top-8 right-8 text-ink/25 group-hover:text-rose transition-colors duration-500">
        <ArrowUpRight size={22} strokeWidth={1.5} aria-hidden="true" />
      </span>
      <span
        className="inline-flex h-14 w-14 items-center justify-center border border-rose/30 text-rose mb-7"
        aria-hidden="true"
      >
        <Icon size={26} strokeWidth={1.25} />
      </span>
      <h3 className="text-2xl lg:text-[1.7rem] text-ink pr-8">{title}</h3>
      <p className="mt-4 text-ink/70 text-[0.95rem] leading-relaxed flex-1">{body}</p>
      <span className="mt-7 eyebrow text-ink group-hover:text-rose transition-colors duration-500">
        {cta}
      </span>
    </Link>
  );
}
